import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloProvider,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import InsuranceApplication from "./routes/Insurance/InsuranceApplication";
import { Success as EsignSuccess } from "./components/EsignRedirect";
import { InvalidUrlError } from "./components/Error";

import "tachyons/css/tachyons.min.css";
import { environments } from "./constants";

function App() {
  const isSandbox = window.location.pathname
    .split("/")
    .includes(environments.SANDBOX);

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_TEN99_URL,
    headers: {
      "Ten99Policy-Environment": isSandbox
        ? environments.SANDBOX
        : environments.PRODUCTION,
    },
  });

  const authLink = setContext((_, { headers }) => {
    // If the applicant URL opts into Watchman (?ofac_provider=watchman),
    // forward the choice to the API as an explicit header. The browser
    // strips query strings from cross-origin Referer, so we can't rely
    // on the API parsing Referer for this.
    const extraHeaders = {};
    try {
      const urlProvider = new URLSearchParams(window.location.search).get(
        "ofac_provider"
      );
      if (urlProvider === "watchman") {
        extraHeaders["X-OFAC-Provider"] = "watchman";
      }
    } catch (e) {
      // noop — never block a request on header injection
    }
    return {
      headers: {
        ...headers,
        ...extraHeaders,
      },
    };
  });

  const cache = new InMemoryCache();
  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: cache,
  });

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/:iaSession"
            element={<InsuranceApplication client={client} isSandbox={false} />}
          ></Route>
          <Route
            path="sandbox/:iaSession"
            element={<InsuranceApplication client={client} isSandbox={true} />}
          ></Route>
          <Route path="esign/success" element={<EsignSuccess />}></Route>
          <Route path="/" element={<InvalidUrlError />}></Route>
        </Routes>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
